import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { deleteRecommendation } from '../../../../api/recommendation';
import {changeDeleteRecommendationModalVisibility, setRecommendationToDelete, setRecommendationsList} from "../../../../store/recommendationSlice"
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
};

const DeleteRecommendation = ({ isOpen }: Props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const { recommendationToDelete, recommendationsList } = useSelector(
    (state: RootState) => state.recommendations
  );
  const onDeleteClick = async () => {
    setLoading(true);
    try {
      if (recommendationToDelete) await deleteRecommendation(recommendationToDelete.id as number);
      dispatch(setRecommendationToDelete(null));
      dispatch(changeDeleteRecommendationModalVisibility(false));
      toast.success('Recommendation deleted successfully');
      dispatch(
        setRecommendationsList({
          recommendations: recommendationsList?.recommendations.filter(
            (recommendation) => recommendation.id !== recommendationToDelete?.id
          ) || []
        })
      );
    } catch (error) {
      console.log('error :>> ', error);
      toast.error('Cannot delete recommendation with assigned members');
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={() => {
      dispatch(setRecommendationToDelete(null));
      dispatch(changeDeleteRecommendationModalVisibility(false));
    }} width={'420px'}>
      <div className='delete-block-container'>
        <div className='modal-header'>
          <div className='title'>Are you sure you want to delete recommendation?</div>
          <div className='sub-title'>All data will be permanently removed.</div>
        </div>

        <div className='submit-btn-wrapper'>
          <Button
            text='Cancel'
            onClick={() => {
              dispatch(setRecommendationToDelete(null));
              dispatch(changeDeleteRecommendationModalVisibility(false));
            }}
            backgroundColor={'#ffffff'}
            color={'#2D334E'}
          />
          <Button text='Delete' onClick={onDeleteClick} isLoading={loading} />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRecommendation;
